import { render } from "./introduce.vue?vue&type=template&id=41638ba8&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"

import "./introduce.vue?vue&type=style&index=0&id=41638ba8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41638ba8"]])

export default __exports__